@if (workplaceId) {
  <p-card>
    <app-table
      #addressesTable
      [gridData]="$any(store.data.workplaceAddresses$ | async)"
      [columns]="columns"
      translatePrefix="workplace.addresses."
      [tableTitle]="'workplace.addresses.title'"
      [hideCheckboxes]="true"
      (createCallback)="openCreateAddress()"
      (detailCallback)="openEditAddress($event)"
      (deleteCallbackWithEvent)="delete($event)"
      [refreshCallback]="store.api.getWorkplaceAddresses"
      [additionalFilter]="addressesAdditionalFilter"
      [defaultSorters]="[{ column: 'validFrom', direction: 'DESC' }]"
    ></app-table>
  </p-card>
}

<p-dialog
  header="{{ ('workplace.addresses.form.' + (form.controls.id.value ? 'edit' : 'create') + 'Header') | translate }}"
  [(visible)]="modalVisible"
  [modal]="true"
  [maximizable]="false"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeModal()"
  >
  <div class="grid-1col input-grid-gaps">
    <app-date-input [form]="form" id="validFrom"></app-date-input>
    <span class="w-full">
      <app-address-input
        id="address"
        [form]="form"
      ></app-address-input>
    </span>
    <app-text-area-input
      id="note"
      [form]="form"
      label="workplace.addresses.form.note"
    ></app-text-area-input>
  </div>

  <ng-template pTemplate="footer">
    <app-action-buttons (primaryClickEvent)="submit()" (secondaryClickEvent)="closeModal()"></app-action-buttons>
  </ng-template>
</p-dialog>
